module.exports = __webpack_public_path__ + "fonts/Inter-100-cyrillic23.06ab411.woff2";